import Audiencies from 'components/3cat/Audiencies';
import MenuError from 'components/3cat/MenuError';
import NotFound from 'components/3cat/NotFound';
import { isEmbedPath, isWebviewPath } from 'utils/pathHelper';

const isWebviewActive = (asPath) => {
    return isWebviewPath(asPath) || isEmbedPath(asPath);
};

const Error = (props) => {
    const { statusCode, asPath } = props;

    return (
        <>
            <Audiencies tipus='errorPage' />
            {!isWebviewActive(asPath) && <MenuError />}
            <NotFound code={statusCode} text={statusCode === 404 ? 'Pàgina no trobada' : 'Error a la pàgina'} />
        </>
    );
};

export default Error;
